import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The customer group code is the encrypted value of the customer group ID, which determines discounts and tax class for pricing contexts. For B2B implementations, the customer group ID also determines the Shared Catalog context.`}</p>
    <p>{`Use one of the following codes for a default customer group based on your requirements.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Customer Group`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Code`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`NOT LOGGED IN`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`b6589fc6ab0dc82cf12099d1c2d40ab994e8410c`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`General`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`356a192b7913b04c54574d18c28d46e6395428ab`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Wholesale`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`da4b9237bacccdf19c0760cab7aec4a8359010b0`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Retailer`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`77de68daecd823babbb58edb1c8e14d7106e83bb`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`For merchant-defined groups, the customer group code is the encrypted value of the ID, `}<inlineCode parentName="p">{`sha1(<customer_group_id>)`}</inlineCode>{`.`}</p>
    <p>{`For B2B implementations, the customer group code is the encrypted value of the customer group ID associated with the shared catalog, `}<inlineCode parentName="p">{`sha1(<customer_group_id>)`}</inlineCode>{`.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Find a list of available customer group IDs from the Admin (`}<strong parentName="p">{`Customers`}</strong>{` > `}<strong parentName="p">{`Customer Groups`}</strong>{`). For details, see `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce-admin/customers/customer-groups"
      }}>{`Customer Groups`}</a>{` and `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce-admin/b2b/shared-catalogs/catalog-shared"
      }}>{`Shared Catalogs`}</a>{` in the `}<em parentName="p">{`Merchant Guide`}</em>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      